/**
 * <DateRangeField />
 *
 * @parent anybody
 * @children
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import { DateRangePicker } from 'components/UI/Form/Fields'

class DateRangeField extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange({ startDate, endDate }) {
    let {
      onChange,
    } = this.props;

    if (startDate && endDate) {
      onChange({ startDate, endDate });
    } else if (!startDate && !endDate) {
      onChange({ startDate, endDate });
    }
  }

  render() {
    return (
      <div className='filter-by-field'>
        <DateRangePicker {...this.props} {...this.props.options} onChange={this.onChange} />
      </div>
    )
  }
}

export default DateRangeField;



// WEBPACK FOOTER //
// ./src/template/FilterBy/filters/DateRangeFilter.js